import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { cx } from '@/utils';
import { t } from '@lingui/macro';
import { Button, Dialog, DialogBody, DialogFooter, DialogHeader } from '@material-tailwind/react';

import { useModalInfoStore } from '@/utils/store/store';

import SvgCheckCircle from '../Icons/CheckCircle';
import SvgExclamationCircle from '../Icons/ExclamationCircle';

const SUCCESS = 'success';
const ERROR = 'error';
//const INFO = 'info'

const ModalGeneral = () => {
  const { modalVisible, showVisible, message, type, onConfirm, reload } = useModalInfoStore();
  const { reload: reloadPage } = useRouter();

  const textColor = useMemo(() => {
    switch (type) {
      case ERROR:
        return 'text-red-900';
      case SUCCESS:
        return 'text-greenDark';
      default: {
        return 'text-tundora';
      }
    }
  }, [type]);

  const bgColor = useMemo(() => {
    switch (type) {
      case ERROR:
        return 'bg-redDark hover:bg-red-900';
      case SUCCESS:
        return 'bg-elfGreen hover:bg-greenDark';
      default: {
        return 'bg-primary hover:!bg-primary';
      }
    }
  }, [type]);

  const icon = useMemo(() => {
    switch (type) {
      case ERROR:
        return <SvgExclamationCircle className="text-redDark" width={60} height={60} />;
      case SUCCESS:
        return <SvgCheckCircle className="text-elfGreen" width={60} height={60} />;
      default: {
        return <SvgExclamationCircle className="text-marine" width={60} height={60} />;
      }
    }
  }, [type]);

  const handleOpen = () => {
    showVisible({ modalVisible: !modalVisible });
    if (onConfirm) {
      onConfirm();
    } else if (reload) {
      reloadPage();
    }
  };

  return (
    <>
      <Dialog
        open={modalVisible}
        handler={showVisible}
        dismiss={{
          escapeKey: false,
          outsidePress: false,
          referencePress: false,
          enabled: false,
        }}
      >
        <DialogHeader className="flex flex-col justify-center pb-0">{icon}</DialogHeader>
        <DialogBody className="flex flex-col items-center overflow-hidden text-center font-workSans">
          <label className={cx('font-workSans text-[20px] font-semibold', textColor)}>
            {message}
          </label>
        </DialogBody>
        <DialogFooter className="items-center justify-evenly">
          <Button
            variant="text"
            onClick={handleOpen}
            className={cx('rounded-[100px] px-10 text-[16px] capitalize text-white', bgColor)}
          >
            <span>{'Entendido'}</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default ModalGeneral;
